<template>
  <div class="tech-stack-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Stack Tecnológico</span>
        <h2>Trabalhamos com as melhores tecnologias do mercado</h2>
        <p>Utilizamos ferramentas modernas e consolidadas para garantir performance, escalabilidade e segurança em cada projeto.</p>
      </div>

      <div class="tech-categories">
        <!-- Frontend -->
        <div class="tech-category" data-aos="fade-up">
          <h3><i class="ph-device-mobile"></i> Frontend</h3>
          <div class="tech-grid">
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React">
              </div>
              <span>React</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" alt="Vue.js">
              </div>
              <span>Vue.js</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" alt="Next.js">
              </div>
              <span>Next.js</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nuxtjs/nuxtjs-original.svg" alt="Nuxt.js">
              </div>
              <span>Nuxt.js</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" alt="TypeScript">
              </div>
              <span>TypeScript</span>
            </div>
          </div>
        </div>

        <!-- Backend -->
        <div class="tech-category" data-aos="fade-up" data-aos-delay="100">
          <h3><i class="ph-database"></i> Backend</h3>
          <div class="tech-grid">
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js">
              </div>
              <span>Node.js</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python">
              </div>
              <span>Python</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" alt="PHP">
              </div>
              <span>PHP</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg" alt="Laravel">
              </div>
              <span>Laravel</span>
            </div>
          </div>
        </div>

        <!-- Mobile -->
        <div class="tech-category" data-aos="fade-up" data-aos-delay="200">
          <h3><i class="ph-device-mobile-camera"></i> Mobile</h3>
          <div class="tech-grid">
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg" alt="Flutter">
              </div>
              <span>Flutter</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React Native">
              </div>
              <span>React Native</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg" alt="Swift">
              </div>
              <span>Swift</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg" alt="Kotlin">
              </div>
              <span>Kotlin</span>
            </div>
          </div>
        </div>

        <!-- Database & Cloud -->
        <div class="tech-category" data-aos="fade-up" data-aos-delay="300">
          <h3><i class="ph-cloud"></i> Database & Cloud</h3>
          <div class="tech-grid">
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL">
              </div>
              <span>PostgreSQL</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" alt="MongoDB">
              </div>
              <span>MongoDB</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" alt="AWS">
              </div>
              <span>AWS</span>
            </div>
            <div class="tech-item">
              <div class="tech-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" alt="Docker">
              </div>
              <span>Docker</span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-5" data-aos="fade-up">
        <a href="https://wa.me/5554992302401?text=Quero saber mais sobre as tecnologias que vocês utilizam"
           target="_blank"
           class="btn-style-one blue-dark-color"
           rel="noopener noreferrer">
          Vamos conversar sobre seu projeto
          <i class="ph-caret-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechStack'
}
</script>

<style scoped>
.tech-stack-area {
  background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
}

.tech-categories {
  display: grid;
  gap: 40px;
  margin-top: 50px;
}

.tech-category {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tech-category:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.tech-category h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tech-category h3 i {
  font-size: 24px;
  color: #6D5DFC;
}

.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
}

.tech-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tech-item:hover {
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.1) 0%, rgba(67, 97, 238, 0.1) 100%);
  transform: scale(1.05);
}

.tech-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
}

.tech-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.tech-item span {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .tech-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .tech-category {
    padding: 20px;
  }
}
</style>